let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bHxrz")).then(() => parcelRequire('T5PvZ'));